import axios from "axios";
import { CRM_INTAKE_URL, CRM_INTAKE_TOKEN } from "src/constants/configs";

const crmInstance = axios.create({
  baseURL: CRM_INTAKE_URL,
  timeout: 10_000,
  headers: {
    "Content-Type": "application/json",
    "x-intake-public-token": CRM_INTAKE_TOKEN ?? "",
  },
});

// voithru-crm intake deal payload (companyName 제외)
export interface IntakeDealPayload {
  source: string;
  submissionId: string;
  serviceLine: string;
  leadSourceLabel: string;
  translationTypeLabel: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  languagePair: string;
  amount: number;
  intakeResponse: string;
  importRemarks: string;
}

export interface IntakeDealResponse {
  ok: boolean;
  duplicate: boolean;
  dealId: string;
}

export const postIntakeDeal = (payload: IntakeDealPayload) =>
  crmInstance.post<IntakeDealResponse>("/api/intake/deal", payload);
